function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.97 13"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.52 1v11M1 6.53h10.97",
    style: {
      fill: "none",
      stroke: "#b959b3",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }));
};
export default SvgPlus;